import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import clsx from "clsx";
import css from "./LeadCountByVoivodeship.module.css";


interface LeadCountByVoivodeshipProps {
    voivodeship: string | number;
    count: number;
}

export const LeadCountByVoivodeship: React.FC<LeadCountByVoivodeshipProps> = ({
    voivodeship,
    count
}: LeadCountByVoivodeshipProps) => {
    return (
        <>
            <Box className={clsx(css.leadCountByVoivodeship)}>
                <Box className={clsx(css.item)}>
                    <Typography variant="body1">Epid</Typography>
                    <Typography variant="h6">{voivodeship}</Typography>
                </Box>

                <Box className={clsx(css.item)}>
                    <Typography variant="body1">Ilość lidów</Typography>
                    <Typography variant="h6">{count}</Typography>
                </Box>
            </Box>
        </>
    );
};
